import AbstractTrack from 'common/services/doxy-analytics/abstract.track';
import { RootScopeEvents } from 'common/services/root-scope-types';
export default class AnalyticsFilterTrack extends AbstractTrack {
    constructor() {
        super(...arguments);
        this.eventNameSegment = 'Filter Selected';
    }
    start() {
        this.$rootScope.$on(RootScopeEvents.ANALYTICS.FILTER, ($e, data) => {
            this.trackSegment(data, true);
        });
    }
}
